var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.new_tab || _vm.item.link)?_c('a',{attrs:{"target":_vm.item.new_tab ? '_blank' : '_self',"href":_vm.item.link
      ? _vm.item.link
      : _vm.$router.resolve(
          _vm.findUrl(_vm.item.linkable_type, _vm.item.linkable_id, _vm.item.slug, _vm.item.link)
        ).href}},[_vm._t("default")],2):_c('router-link',{attrs:{"to":_vm.findUrl(_vm.item.linkable_type, _vm.item.linkable_id, _vm.item.slug)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }